import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Spikacz",
  pwaServiceName: "Spikacz",
  appLogoPath: "/partner/questfe/logo.png",
  appLogoHeight: "50px",
  landingLogoPath: "/partner/questfe/logo.png",
  landingLogoHeight: "60px",
  hubLogoPath: "/partner/questfe/logo.png",
  hubLogoHeight: "60px",
  favicon: "/partner/questfe/icon.png",
  pwaIcons: [
    {
      src: "/partner/questfe/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "spikacz@questfe.pl",
  adminEmail: "spikacz.admin@questfe.pl",
  authErrorPath:
    "https://questfe.pl/wp-login.php?redirect_to=https%3A%2F%2Fquestfe.pl%2Fspikacz-logowanie%2F",
  authSignInPath:
    "https://questfe.pl/wp-login.php?redirect_to=https%3A%2F%2Fquestfe.pl%2Fspikacz-logowanie%2F",
  reviewLink: null,
  copyright: "Spikacz",
  showLanguageGuides: true,
  bioPrompt: `
    You are a tutor at Spikacz.
  `,
  fontLink: "/partner/questfe/fonts.css",
  fonts: {
    heading: `"Barlow", sans-serif`,
    body: `"Barlow", sans-serif`,
  },
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-primary-main)",
      speakInputRecording: "var(--chakra-colors-brand-tertiary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-tertiary-900)",
    },
  },
  colors: {
    primary: {
      main: "#2f2a80",
      mainContrast: "#fff",
      "50": "#f7f7fa",
      "100": "#e0dfec",
      "200": "#c5c3db",
      "300": "#a4a2c8",
      "400": "#9290bd",
      "500": "#7a77ae",
      "600": "#6662a2",
      "700": "#504c94",
      "800": "#413d8b",
      "900": "#2c2778",
    },
    secondary: {
      main: "#ff6d3f",
      mainContrast: "#000",
      "50": "#fff5f2",
      "100": "#ffd8cb",
      "200": "#ffb49c",
      "300": "#ff825b",
      "400": "#f5693c",
      "500": "#ce5833",
      "600": "#ae4b2b",
      "700": "#8c3c23",
      "800": "#77331d",
      "900": "#562515",
    },
    tertiary: {
      main: "#ff6d3f",
      mainContrast: "#000",
      "50": "#fff5f2",
      "100": "#ffd8cb",
      "200": "#ffb49c",
      "300": "#ff825b",
      "400": "#f5693c",
      "500": "#ce5833",
      "600": "#ae4b2b",
      "700": "#8c3c23",
      "800": "#77331d",
      "900": "#562515",
    },
  },
};
